export default __webpack_public_path__ + "static/media/remove-circle-outline-grey.c16ff2b2.svg";